mutation DeleteHifo($id: ID!) {
  deleteHifo(input: { id: $id }) {
    success
  }
}
